import React, { Component } from 'react';

export class FstyrRadioButtonGroup extends Component {

  /*
  PROPS:

  label
  choices
  onClick
  */

  constructor(props) {
    super(props);

    this.state = {
      value: "",
    };
  }

  componentDidMount() {
    if (this.props.value) {
      this.props.onClick(this.props.value);
      this.setState({ value: this.props.value })
    }
  }

  componentDidUpdate(prevState) {
    if (prevState.value !== this.props.value) {

      if (this.props.value) {
        this.props.onClick(this.props.value);
        this.setState({ value: this.props.value })
      }
    }
  }

  render() {
    return (
      <div className={"fstyr-radio-button-group"}>
        <label className="form-label" htmlFor="input-antal">
          {this.props.label}
        </label>
        {
          this.props.choices.map((value, i) =>
            <div type='item' key={i}>
              <div type='button'
                onClick={() => { this.props.onClick(value); this.setState({ value: value }) }}
              >
                {this.state.value === value ?
                  <div className="fstyr-radio-button-group-selected"></div>
                  :
                  <div></div>
                }
              </div>
              {value}
            </div>
          )
        }
      </div >
    );
  }
}